import React from 'react'
import pkg from "../../../package.json";
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <footer className="site__footer">
            <div className="site__footer__inner">
                <span className="site-footer-copy">
                    © {new Date().getFullYear()} SaffronOS. All rights reserved.
                </span>
                <span className="site-footer-copy" style={{ opacity: 0.55 }}>
                    v{pkg.version} &nbsp;·&nbsp; Updated {new Date(pkg.lastUpdated).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                </span>
                <nav className="site-footer-links">
                    <Link to="/terms-of-service" className="site-footer-link">Terms of Service</Link>
                    <span className="site-footer-sep" aria-hidden="true">·</span>
                    <Link to="/privacy-policy" className="site-footer-link">Privacy Policy</Link>
                </nav>
            </div>
        </footer>
    )
}
